const formatInscription = str => {
  var weirdApostrophe = /[\u2018-\u2019]/g;

  return (str || '')
    .replace(weirdApostrophe, "'");
};

module.exports = formatInscription;



// WEBPACK FOOTER //
// ./src/common/utils/format-inscription.js